import { Document, AlertErrorCircle } from '@/assets/icons'
import { Tooltip } from '@mui/material'
import { CircularProgressContinuousSized } from '@/components/loaders/CircularProgressContinuous'
import { FullMetadata } from 'firebase/storage'
import { determineGcsFileStatus, FileProcessingStage } from '@/routes/dashboard/files/utils/gcs-file-metadata-logic'
import { GCSFileMetadataStatusIndicator } from '@/routes/dashboard/files/utils/gcs-file-self-assessment'

function getIcon(status?: GCSFileMetadataStatusIndicator) {
  switch (true) {
    case status === GCSFileMetadataStatusIndicator.PROCESSING:
      return <CircularProgressContinuousSized className="ml-1 mr-1" size={16} thickness={7} />
    case status === GCSFileMetadataStatusIndicator.DONE:
      return <Document className="w-5 h-5" />
    default:
      return <AlertErrorCircle className={'size-5 text-white bg-red-600 rounded-full'} />
  }
}

interface SourceSelectDynamicFileIconProps {
  fileMetadata?: FullMetadata
  fileReadyAtStage?: FileProcessingStage
}

export default function SourceSelectDynamicFileIcon(props: SourceSelectDynamicFileIconProps) {
  const { fileMetadata, fileReadyAtStage } = props

  const fileStatus = fileMetadata ? determineGcsFileStatus({ fileMetadata, fileReadyAtStage }) : undefined
  const message =
    fileStatus === undefined || fileStatus.status === GCSFileMetadataStatusIndicator.ERROR
      ? fileStatus?.errorMessage ?? 'Error processing file, please try again'
      : undefined

  return (
    <div className="inline-flex align-middle">
      {message ? (
        <Tooltip title={message} placement="top">
          <span>{getIcon(fileStatus?.status)}</span>
        </Tooltip>
      ) : (
        <span>{getIcon(fileStatus?.status)}</span>
      )}
    </div>
  )
}
